import * as _ from "lodash";
import { DocumentIsogd, DocumentOrganization } from "isogd-document-rest";

class DocumentOrganizationEditController {
    private document: DocumentIsogd;
    private orgRoles: any[];
    private orgTypes: any[];

    onOrganizationRoleChange(ind: number) {
        let orgRole = _.find(this.orgRoles, o => {
            return o.roleCode == this.document.organizations[ind].organizationRoleCode;
        });
        this.document.organizations[ind].organizationRole = orgRole.roleName;
    }

    onOrganizationTypeChange(ind: number) {
        let orgType = _.find(this.orgTypes, o => {
            return o.typeCode == this.document.organizations[ind].organizationTypeCode;
        });
        this.document.organizations[ind].organizationType = orgType.typeName;
    }

    public onAddOrganizationClick(): void {
        let newOrganization: DocumentOrganization = new DocumentOrganization();
        
        if (!this.document.organizations) {
            this.document.organizations = [];
        }
        this.document.organizations.push(newOrganization);
    }

    public onRemoveOrganizationClick(idx): void {
        this.document.organizations.splice(idx, 1);
    }

}

export const DocumentOrganizationEditComponent: angular.IComponentOptions = {
    controller: DocumentOrganizationEditController,
    template: require('./documentOrganizationEdit.html'),
    bindings: {
        document: "<",
        orgRoles: "<",
        orgTypes: "<"
    }
};


// WEBPACK FOOTER //
// ./src/components/document/document-organization/documentOrganizationEdit.ts